import { render } from "./PersonalShow.vue?vue&type=template&id=2232779b"
import script from "./PersonalShow.vue?vue&type=script&lang=js"
export * from "./PersonalShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__